<template>
    <el-popconfirm
        placement="top"
        confirm-button-text='是的'
        confirm-button-type='danger'
        cancel-button-text='不用了'
        icon="el-icon-info"
        icon-color="#909399"
        title="确定拉黑该博主吗？"
        :disabled="!visible"
        @confirm="blackIt_">
        <!-- TODO, configure the styels.-->
        <my-link slot="reference" class="margin-left-8px" style="font-size: 13px" @click.native="open">拉黑</my-link>
    </el-popconfirm>
</template>

<script>

    import { CachedApiSecurity } from "../../api-security";
    import { blackIt } from "../../data/user";
    import { GlobalLoading, successMessage } from "../../utils";

    export default {
        name: "Blacklist",
        props: {
            type: String,
            code: String,
        },
        data(){
            return {
                visible: false,
            }
        },
        methods: {
            open(){
                console.log('Tipoff, try to open');
                if (!CachedApiSecurity.isSignedIn())
                    CachedApiSecurity.handleNoAuthorith();
                else{
                    this.visible = true;
                }
            },
            /**
             * 1. save it into db
             * 2. sync the client cache
             * 3. remove all contents associated with it at page.
             * @private
             */
            blackIt_(){
                console.log(`black it with the target type: ${this.type}, and the target code: ${this.code}`);
                GlobalLoading.start();
                window.setTimeout(async()=>{
                    try {
                        console.log(`black it, try to black {${this.type}, ${this.code}}`);
                        await blackIt(this.type, this.code); // 后台会同时删除 follows
                        this.$store.commit('removeFollows', this.code); // 同时将其从页面的缓存列表中删除
                        // 发送成功事件，PC 端需要获取该事件关闭 popup entity window @deprecated PC 没有拉黑
                        // this.$EventBus.$emit('black-profile', this.code);
                        // push to its channel and reload the page.
                        console.log(`black it, forward to ${this.$store.state.currentChannelCode}`);
                        successMessage('拉黑成功');
                        window.setTimeout(()=>{
                            this.$router.push({path: `/c/${this.$store.state.currentChannelCode}?update=true`});
                        },300)
                    } catch(error){
                        console.error(error);
                    } finally {
                        GlobalLoading.stop();
                    }
                }, 300)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/Blacklist.vue